<template>
  <fh-container>
    <fh-title>Reseteo de Pin</fh-title>

    <fh-card>
      <v-form v-if="isUrlValid" ref="form" v-model="valid" lazy-validation>

        <!-- New Pin -->
        <v-text-field
          :rules="newPinRules"
          @keyup.enter="handleResetPin"
          @input="validatePin"
          label="Pin nuevo"
          type="password"
          inputmode="numeric"
          v-model="newPin"
          autocomplete="new-password"
          autofocus
        ></v-text-field>

        <!-- New Pin 2 -->
        <v-text-field
          :rules="newPinRules2"
          @keyup.enter="handleResetPin"
          @input="validatePin"
          label="Confirmar pin nuevo"
          type="password"
          inputmode="numeric"
          v-model="newPin2"
          autocomplete="new-password"
        ></v-text-field>

        <v-row justify="center" class="pt-3">
          <v-btn @click="handleResetPin" color="primary">
            Guardar
          </v-btn>
        </v-row>

      </v-form>

      <div v-else class="text-center red--text">
        Enlace de reseteo no válido o expirado
      </div>
    </fh-card>
  </fh-container>
</template>

<script>
import FhContainer from '@/components/FhContainer'
import FhTitle from '@/components/FhTitle'
import FhCard from '@/components/FhCard'
import { mapActions } from 'vuex'
import UsuarioRepository from '@/services/UsuarioRepository'

export default {
  name: 'ResetPin',
  components: { FhCard, FhTitle, FhContainer },
  data () {
    return {
      valid: true,
      // Defer validation until first submit attempt
      isSubmit: false,
      newPin: '',
      newPinRules: [
        v => !!v || 'Campo obligatorio'
      ],
      newPin2: '',
      newPinRules2: [
        v => !!v || 'Campo obligatorio',
        v => !this.isSubmit || v === this.newPin || 'Pin deben coincidir'
      ]
    }
  },
  computed: {
    url () {
      return this.$route.params.url
    },
    isUrlValid () {
      return this.url && this.url.length > 20
    }
  },
  methods: {
    ...mapActions('snackbar', [
      'showSnackbar'
    ]),
    validatePin () {
      // Only validate if the confirmation pin is set
      if (this.newPin2) {
        this.$refs.form.validate()
      }
    },
    async handleResetPin () {
      try {
        this.isSubmit = true
        if (!this.$refs.form.validate()) { return }

        await UsuarioRepository.resetPin(this.url, this.newPin)
        this.showSnackbar(['Reseteo exitoso! Ahora puede iniciar sesión con el nuevo pin.', 'success'])
        this.$router.push({ name: 'Home' })
      } catch (e) {
        //
      }
    }
  }
}
</script>

<style scoped>

</style>
